// extracted by mini-css-extract-plugin
module.exports = {"keyStats":"style_keyStats__RH79M","head":"style_head__b8eJp","item":"style_item__O9B_3","halfItem":"style_halfItem__cB1ZF"};